import * as React from 'react';
export const StateContext = React.createContext(undefined);
export default StateContext;
//# sourceMappingURL=stateContext.js.map